export default "__VITE_ASSET__DyDJilb1__"